import { ButtonCheck } from 'components/ButtonCheck'
import { CounterInput } from 'components/CounterInput'
import { Separator } from 'components/Separator'
import { Formik } from 'formik'
import { useAmenitiesQuery } from 'hooks/useAmenitiesQuery'
import { useServicesQuery } from 'hooks/useServicesQuery'
import { ComponentType, useState } from 'react'
import { Col, Label, Row } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'
import { hasFilters } from 'utils/filters'
import { Filter } from 'views/search/filter'

const Form = styled.form`
  display: flex;
  flex-direction: column;
  max-height: inherit;

  ${up('sm')} {
    max-height: 50vh;
  }
`

const Body = styled.div`
  flex: 1 1 auto;
  padding: 20px;
  overflow: auto;

  ${up('sm')} {
    padding: 32px;
    width: 550px;
  }
`

const Footer = styled.div`
  flex: 0 0 auto;
  display: flex;
  justify-content: space-between;
`

const Action = styled.button`
  border: 0;
  background: transparent;
  padding: 16px 20px;
  font-size: 14px;

  ${up('sm')} {
    padding: 16px 32px;
  }
`

const Reset = styled(Action)`
  color: #757d88;
`

const Apply = styled(Action)`
  color: #2068af;
`

interface Props {
  query: any
  onSubmit: (changes: any) => void
}

export const Details: ComponentType<Props> = ({ query, onSubmit }) => {
  const [isOpen, setIsOpen] = useState(false)
  const handleToggle = () => setIsOpen(!isOpen)

  const amenitiesQuery = useAmenitiesQuery()
  const servicesQuery = useServicesQuery()

  const initialValues = {
    places: { 'floors>': query.places?.['floors>'] ?? '' },
    amenities: query.amenities ?? [],
    services: query.services ?? [],
  }

  const resetValues = {
    places: { 'floors>': '' },
    amenities: [],
    services: [],
  }

  return (
    <Filter label="Más detalles" isOpen={isOpen} isActive={hasFilters(initialValues)} onToggle={handleToggle}>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => {
          onSubmit(values)
          handleToggle()
        }}
      >
        {({ values, setFieldValue, handleBlur, handleChange, handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Body>
              <div className="d-flex justify-content-between">
                <div className="text-trout">Niveles</div>
                <CounterInput
                  value={values.places['floors>']}
                  min={1}
                  max={100}
                  onChange={(v) => setFieldValue('places.floors>', v)}
                />
              </div>
              <Separator className="my-25" />
              <div>
                <Label className="text-trout">Amenidades</Label>
                <Row form>
                  {amenitiesQuery.data?.amenities.data.map((amenity: any) => (
                    <Col key={amenity.uuid} xs={6}>
                      <ButtonCheck
                        type="checkbox"
                        name="amenities"
                        label={amenity.name}
                        checked={values.amenities.includes(amenity.uuid)}
                        value={amenity.uuid}
                        onBlur={handleBlur}
                        onChange={handleChange}
                      />
                    </Col>
                  ))}
                </Row>
              </div>
              <Separator className="my-25" />
              <div>
                <Label className="text-trout">Servicios</Label>
                <Row form>
                  {servicesQuery.data?.services.data.map((service: any) => (
                    <Col key={service.uuid} xs={6}>
                      <ButtonCheck
                        type="checkbox"
                        name="services"
                        label={service.name}
                        checked={values.services.includes(service.uuid)}
                        value={service.uuid}
                        onBlur={handleBlur}
                        onChange={handleChange}
                      />
                    </Col>
                  ))}
                </Row>
              </div>
            </Body>
            <Separator />
            <Footer>
              <Reset
                onClick={() => {
                  onSubmit(resetValues)
                  handleToggle()
                }}
              >
                Borrar
              </Reset>
              <Apply type="submit">Aplicar</Apply>
            </Footer>
          </Form>
        )}
      </Formik>
    </Filter>
  )
}
